import { X } from "lucide-react";

export const inputCls =
  "w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-800 outline-none transition-colors focus:border-[#2d5a3d] focus:ring-2 focus:ring-[#2d5a3d]/15";

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="mb-1 block text-xs font-medium uppercase tracking-wide text-gray-500">{label}</span>
    {children}
  </label>
);

export const Badge = ({ className = "", children }) => (
  <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium ${className}`}>
    {children}
  </span>
);

export const Dot = ({ color }) => (
  <span className="inline-block h-2 w-2 rounded-full" style={{ backgroundColor: color }} />
);

export const Modal = ({ title, onClose, children, wide }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4 backdrop-blur-sm" onClick={onClose}>
    <div
      className={`max-h-[90vh] w-full overflow-y-auto rounded-2xl bg-white shadow-2xl ${wide ? "max-w-2xl" : "max-w-lg"}`}
      onClick={(e) => e.stopPropagation()}
      role="dialog"
      aria-modal="true"
    >
      <div className="sticky top-0 flex items-center justify-between border-b border-gray-100 bg-white px-6 py-4">
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        <button data-testid="modal-close" onClick={onClose} className="rounded-lg p-1.5 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700" aria-label="Cerrar">
          <X className="h-5 w-5" />
        </button>
      </div>
      <div className="px-6 py-5">{children}</div>
    </div>
  </div>
);

export const Drawer = ({ title, onClose, children }) => (
  <div className="fixed inset-0 z-50 flex justify-end bg-black/40 backdrop-blur-sm" onClick={onClose}>
    <div
      className="h-full w-full max-w-xl overflow-y-auto bg-white shadow-2xl"
      onClick={(e) => e.stopPropagation()}
      role="dialog"
      aria-modal="true"
    >
      <div className="sticky top-0 z-10 flex items-center justify-between border-b border-gray-100 bg-white px-6 py-4">
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        <button data-testid="drawer-close" onClick={onClose} className="rounded-lg p-1.5 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700" aria-label="Cerrar">
          <X className="h-5 w-5" />
        </button>
      </div>
      <div className="px-6 py-5">{children}</div>
    </div>
  </div>
);

export const Card = ({ className = "", children }) => (
  <div className={`rounded-2xl border border-gray-100 bg-white shadow-[0_1px_4px_rgba(16,24,40,0.05)] ${className}`}>
    {children}
  </div>
);
